import React from 'react';

const DashboardHeader = () => {
    return (
        <header className="mb-8">
            <div className="text-center mb-6">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
                    ¡Hola! Bienvenido a tu Copiloto de Marketing
                </h1>
                <p className="text-gray-600 text-lg">
                    La IA está aquí para ayudarte a hacer crecer tu negocio
                </p>
            </div>
        </header>
    );
};

export default DashboardHeader; 